// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9r-3";
export var contentContainer = "_9r-0";
export var editorContainer = "_9r-1";
export var quillInputForm = "_9r-2";
export var zoneDivider = "_9r-4";